import React from 'react';
import { educationData } from '../data/educationData';
import './Education.css';

const Education = () => {
  return (
    <section id="education" className="education">
      <div className="container">
        <h2 className="section-title">Education</h2>
        <p className="section-subtitle">
          Academic background
        </p>

        <div className="grid grid-2 education-grid">
          {educationData.map((item, index) => (
            <div key={index} className="card education-card">
              <h3 className="education-degree">{item.degree}</h3>
              <div className="education-institution">{item.institution}</div>

              <div className="education-meta">
                <span className="education-meta-item">{item.location}</span>
                <span className="education-meta-item">{item.period}</span>
              </div>

              {item.details && item.details.length > 0 && (
                <ul className="education-details">
                  {item.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
